module.exports = __webpack_public_path__ + "img/Poorna_Jagannathan_Preston.9aba3f26.jpg";